import { JournalModule } from '@addins/core/journal';
import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SagaPipeModule } from '@app/pipes/module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { JournalModalComponent } from './components/journal-modal/journal-modal.component';
import { StampTextEditorComponent } from './components/stamp-text-editor/stamp-text-editor.component';
import { JournalCardButtonService } from './services/executables/journal-card-button/journal-card-button.service';
import { JournalToolsSetupService } from './services/executables/journal-tools-setup/journal-tools-setup.service';

export const JOURNAL_MODULE_NAME: string = 'SingleCallcardJournal';

const executables = [JournalCardButtonService, JournalToolsSetupService];

const providers = [...executables];

const components = [JournalModalComponent, StampTextEditorComponent];

@Addin({
  name: JOURNAL_MODULE_NAME
})
@NgModule({
  declarations: [...components],
  providers,
  imports: [CommonModule, FormsModule, IonicModule, JournalModule, SagaPipeModule, TranslateModule]
})
export class SingleCallcardJournalModule extends AddinModule {
  constructor(injector: Injector) {
    super(injector, components, executables);
  }
}
